import React from 'react';

interface PanelItemProps {
    children: React.ReactNode;
    itemValue: string;
    expandPanel?: boolean;
    selected?: boolean;
}

const PanelItem: React.FC<PanelItemProps> = ({ children, itemValue, expandPanel, selected }) => {
    return (
        <div className={`flex flex-row w-auto p-4 ${selected ? 'bg-sidemenu-focus text-white' : 'menu-item'}`}>
            <div className="flex">
                <div>
                    {children}
                </div>
                {expandPanel && <p className="ml-2 transition-all duration-300" style={{ fontSize: '12px' }}>{itemValue}</p>}
            </div>
        </div>
    );
};

export default PanelItem;